export default __webpack_public_path__ + "static/media/pdf.e2388416.png";